import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as farHeart } from "@fortawesome/free-regular-svg-icons";
import {
  faHeart as fasHeart,
  faShareAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  WhatsappShareButton,
  FacebookShareButton,
  WhatsappIcon,
  FacebookIcon,
} from "react-share";
import { useWishlist } from "../Context/WishlistContext";
import insta from "../../src/Assets/insta.png";
import toast from "react-hot-toast";
import axios from "axios";
import "./Item.css";

const defaultImage =
  "https://s3-us-west-2.amazonaws.com/s.cdpn.io/1255/image-not-found.svg";

export const Item = ({ 
  id, 
  name, 
  desc, 
  img, 
  price, 
  l1, 
  l2_id,
  isGrouped = false,
  variants = []
}) => {
  const [wishlistClicked, setWishlistClicked] = useState(false);
  const [imageSrc, setImageSrc] = useState(img);
  const [showShareOptions, setShowShareOptions] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const navigate = useNavigate();

  const {
    wishlist = [],
    addToWishlist,
    removeFromWishlist,
  } = useWishlist() || {};

  const accessToken = sessionStorage.getItem("auth");

  const safeVariants = Array.isArray(variants) ? variants : [];
  
  // Determine the actual product to display
  const displayProduct = isGrouped && selectedVariant ? selectedVariant : {
    id,
    name,
    desc,
    img,
    price,
    l1,
    l2_id,
    stock_status: safeVariants[0]?.stock_status || 'in_stock',
    color: safeVariants[0]?.color,
    size: safeVariants[0]?.size   
  };

  const shareUrl = `${window.location.origin}/product/${displayProduct.l1}`;
  const shareMessage = `Check this out:\n${displayProduct.name} ₹${displayProduct.price}`;

  useEffect(() => {
    setWishlistClicked(wishlist.includes(displayProduct.l2_id));
  }, [wishlist, displayProduct.l2_id]);

  useEffect(() => {
    if (isGrouped && safeVariants.length > 0) {
      const availableVariant = safeVariants.find(v => v.stock_status === 'in_stock') || safeVariants[0];
      setSelectedVariant(availableVariant);
    }
  }, [isGrouped, safeVariants]);

  const toggleWishlist = async () => {
    if (!accessToken) {
      toast.error("Please log in to add items to your wishlist.");
      return;
    }
    try {
      if (wishlistClicked) {
        await axios.delete(
          "https://tarunika.backendapihub.com/wishlist/wishlist/remove",
          {
            headers: { "access-token": accessToken },
            data: { productID: displayProduct.l2_id },
          }
        );
        removeFromWishlist(displayProduct.l2_id);
        toast.success("Item removed from wishlist.");
      } else {
        await axios.post(
          "https://tarunika.backendapihub.com/wishlist/wishlist/add",
          { productvariationID: displayProduct.l2_id },
          { headers: { "access-token": accessToken } }
        );
        addToWishlist(displayProduct.l2_id);
        toast.success("Item added to wishlist.");
      }
    } catch (error) {
      toast.error("Something went wrong with the wishlist update.");
    }
  };

  const goToDetailsPage = () => {
    navigate(`/product/${displayProduct.l1}`, { state: { l2_id: displayProduct.l2_id } });
  };

  const handleInstagramShare = () => {
    window.open(`https://www.instagram.com/`, "_blank");
    toast.success("Instagram opened in a new tab. Paste the URL to share!");
  };

  const handleNativeShare = async () => {
    const shareData = {
      title: "Check this out",
      text: shareMessage,
      url: shareUrl,
      image: imageSrc,
    };

    try {
      if (window.innerWidth <= 768 && navigator.share) {
        await navigator.share(shareData);
      } else {
        setShowShareOptions(!showShareOptions);
      }
    } catch (err) {
      console.error("Sharing failed:", err.message);
    }
  };

  const handleVariantChange = (variant) => {
    setSelectedVariant(variant);
  };

  return (
    <div className="carrd">
      <div className="card__thumbnail">
        <img
          src={displayProduct.image || img}
          alt={displayProduct.name}
          onClick={goToDetailsPage}
          onError={(e) => (e.target.src = defaultImage)}
        />
        
        {/* Variant selector for grouped products */}
        {/* {isGrouped && variants && variants.length > 1 && (
          <div className="variant-selector">
            {variants.map((variant, idx) => (
              <button
                key={idx}
                className={`variant-option ${
                  selectedVariant?.l2_id === variant.l2_id ? 'active' : ''
                } ${
                  variant.stock_status !== 'in_stock' ? 'out-of-stock' : ''
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  if (variant.stock_status === 'in_stock') {
                    handleVariantChange(variant);
                  }
                }}
                title={
                  variant.stock_status !== 'in_stock' 
                    ? 'Out of stock' 
                    : variant.color || `Option ${idx + 1}`
                }
              >
                {variant.color_swatch ? (
                  <img 
                    src={variant.color_swatch} 
                    alt={variant.color} 
                    className="color-swatch"
                  />
                ) : (
                  variant.color?.charAt(0) || `O${idx + 1}`
                )}
              </button>
            ))}
          </div>
        )} */}
        
        <div className="icons-container">
          <FontAwesomeIcon
            icon={wishlistClicked ? fasHeart : farHeart}
            className="wishlist-icon text-danger"
            onClick={(e) => {
              e.stopPropagation();
              toggleWishlist();
            }}
          />
          <FontAwesomeIcon
            icon={faShareAlt}
            className="share-alt-icon text-success"
            onClick={(e) => {
              e.stopPropagation();
              handleNativeShare();
            }}
          />
          {showShareOptions && window.innerWidth > 768 && (
            <div className="share-popup-inline" onClick={(e) => e.stopPropagation()}>
              <WhatsappShareButton url={shareUrl} title={shareMessage}>
                <WhatsappIcon size={36} round />
              </WhatsappShareButton>
              <FacebookShareButton url={shareUrl} quote={shareMessage}>
                <FacebookIcon size={36} round />
              </FacebookShareButton>
              <div onClick={handleInstagramShare} className="instagram-icon" style={{ cursor: "pointer", textAlign: "center" }}>
                <img src={insta} alt="Instagram" style={{ width: 36, height: 36, borderRadius: "50%" }} />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="card__body">
        <h5 className="card__title" onClick={goToDetailsPage}>
          {displayProduct.name}
          {isGrouped && selectedVariant && selectedVariant.size && (
            <span className="variant-size"> ({selectedVariant.size})</span>
          )}
        </h5>
        <p className="card__price" onClick={goToDetailsPage}>
          ₹ {displayProduct.price}
          {displayProduct.stock_status !== 'in_stock' && (
            <span className="out-of-stock-badge">Out of Stock</span>
          )}
        </p>
      </div>
    </div>
  );
};

export default Item;